import React, {useEffect, useState, useRef, forwardedRef} from 'react';
import "./Gallery.scss";
import Project from "./../pages/Project";
import {motion} from "framer-motion"

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import {useTranslation} from "react-i18next";
import axios from "axios";

const Gallery = ({forwardedRef}) => {
    const {t, i18n} = useTranslation();
    const [listCategory, setListCategory] = useState([]);

    const ref = useRef();

    // Intersection Observer Configuration
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px', // important: needs units on all values
        threshold: 0
    };

    const animate = element => (
        element.classList.add("fadeIn")
    );

    const isAnimated = element => (
        element.classList.contains("fadeIn")
    );

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, observerInstance) => {
                entries.forEach(
                    entry => {

                    }
                );
            },
            observerOptions
        );
        if (ref.current) {
            observer.observe(ref.current);
        }

        axios.get(`http://www.studiosignorello.it/wp/wp-json/wp/v2/categoria`)
            .then(res => {
                setListCategory(res.data);
            })

    }, [ref]);

    return (
        <div className="gallery__container" ref={forwardedRef}>
            <div className="section__header">
                <div className="section__header--line"></div>
                <h5 className="section__header--title">{t('projects')}</h5>
            </div>
            <div className="row photo__container">
                {listCategory.length > 0 && <div className="column">
                    {listCategory.map((category, index) => {
                            if (index >= 0 && index <= 2)
                                return <motion.div whileHover={{opacity: 1, y: -2}} style={{opacity: 0.5}}
                                                   key={category.id} className="category__box">
                                    <Link to="/project/1">
                                        <img className="item" src={category.acf.image}/>
                                    </Link>
                                    <p className="photo__text">{category.title.rendered}</p>
                                </motion.div>
                            return null;
                        }
                    )}
                </div>}
                {listCategory.length > 3 && <div className="column">
                    {listCategory.map((category, index) => {
                            if (index > 2 && index <= 4)
                                return <motion.div whileHover={{opacity: 1, y: -2}} style={{opacity: 0.5}}
                                                   key={category.id} className="category__box">
                                    <Link to="/project/1">
                                        <img className="item" src={category.acf.image}/>
                                    </Link>
                                    <p className="photo__text">{category.title.rendered}</p>
                                </motion.div>
                            return null;
                        }
                    )}
                </div>}
                {/*<div className="column">*/}
                {/*<img className="item" src={require('./../assets/images/ocean.jpg')}/>*/}
                {/*<img className="item" src={require('./../assets/images/wedding.jpg')}/>*/}
                {/*</div>*/}
                {/* <div className="column">*/}
                {/*<img className="item" src={require('./../assets/images/wedding.jpg')}/>*/}
                {/*<img className="item" src={require('./../assets/images/ocean.jpg')}/>*/}
                {/*<img className="item" src={require('./../assets/images/falls2.jpg')}/>*/}
                {/*</div>*/}
            </div>


        </div>
    );
};

export default Gallery;
